import { httpV2 } from "@/api";

/**
 * Obtém um conjunto de amostras de tendências de valores globais e tendências de
 * frequência para um gráfico de domínio personalizado.
 * @param {object} parameters - Modelo contendo ids das tendências e período de tempo.
 */
const GetScatterChartData = async function(parameters)
{
	return httpV2.post("/TrendScatterCharts/", parameters);
};

/**
 * Obtém um conjunto de amostras de tendências de valores globais e tendências de frequência para
 * um gráfico de dominio personalizado em formato de CSV.
 * @param {object} parameters - Parâmetros necessários para a requisição.
 * @returns {object} Arquivo no formato csv para download.
 */
const GetScatterChartCSV = async function(parameters)
{
	return httpV2.post("/TrendScatterCharts/CSV", parameters);
};

/**
 * Obtém um conjunto de amostras de tendências de valores globais e tendências de frequência
 * para um gráfico estratificado.
 * @param {object} parameters - Modelo contendo ids das tendências e período de tempo.
 */
const GetStratifiedScatterChartData = async function(parameters)
{
	return httpV2.post("/TrendScatterCharts/Stratification", parameters);
};

/**
 * Obtém um conjunto de amostras de tendências de valores globais e tendências de frequência para
 * um gráfico de dominio personalizado em formato de CSV.
 * @param {object} parameters - Parâmetros necessários para a requisição.
 * @returns {object} Arquivo no formato csv para download.
 */
const GetStratifiedScatterChartCSV = async function(parameters)
{
	return httpV2.post("/TrendScatterCharts/Stratification/CSV", parameters);
};

export default {
	GetScatterChartData,
	GetStratifiedScatterChartData,
	GetScatterChartCSV,
	GetStratifiedScatterChartCSV,
};
